import { devtools } from "zustand/middleware";
import { createWithEqualityFn } from "zustand/traditional";

const useStore = createWithEqualityFn(
  devtools((set, get) => ({
    data: null,
    types: null,
    metadata: null,
    actions: {
      // =======================
      // STATE ACTIONS SETTERS
      // =======================
      handleSetReportData: (data) => {
        set((s) => ({
          data: {
            ...s.data,
            ...data,
          },
        }));
      },
      handleSetDataTypes: (data) => {
        set((s) => ({
          types: {
            ...s.types,
            ...data,
          },
        }));
      },
      handleSetMetadata: (data) => {
        set((s) => ({
          metadata: {
            ...s.data,
            ...data,
          },
        }));
      },
    },
  }))
);

export default useStore;
